import React from 'react';

function CollectionsItemDescription({ description }) {
	return (
		<div className="collections-item__description">
			<p>{description}</p>
		</div>
	);
}

export default CollectionsItemDescription;
